import CustomButton from "../../../Components/Buttons/Custom";

export default function TopMessage({ variant }) {
  return (
    <section className="w-full h-fit bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5">
      <div className="flex items-center justify-between gap-5">
        <p className="text-sm md:text-base font-medium text-zi-text-light dark:text-zi-text-dark">
          خوش آمدید!
        </p>
      </div>
    </section>
  );
}
